import React from "react";

const defaultShareData = [
  {
    entityName: "",
    entityType: "",
    sharePercent: "",
  },
];

const ShareholdingTable = ({ shareholdingTable, setShareholdingTable }) => {
  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = [...shareholdingTable];
    updatedData[rowIndex][field] = value;
    setShareholdingTable(updatedData);
  };

  const addRow = () => {
    setShareholdingTable([
      ...shareholdingTable,
      {
        entityName: "",
        entityType: "",
        sharePercent: "",
      },
    ]);
  };

  const removeRow = () => {
    if (shareholdingTable.length > 1) {
      setShareholdingTable(shareholdingTable.slice(0, -1));
    }
  };

  const entityTypes = [
    "Holding",
    "Subsidiary",
    "Associate Company",
    "Joint Venture",
  ];

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <div
          style={{
            border: "1px solid #000",
            overflow: "hidden",
            borderRadius: "8px",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#D3C9CE", color: "#000" }}>
                <th style={tableHeaderStyle}>S. No.</th>
                <th style={tableHeaderStyle}>Entity Name</th>
                <th style={tableHeaderStyle}>Type Of Entity</th>
                <th style={tableHeaderStyle}>
                  % of shares held by the listed Entity
                </th>
              </tr>
            </thead>
            <tbody>
              {shareholdingTable.map((row, index) => (
                <tr key={index}>
                  <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                    {index + 1}
                  </td>
                  <td style={tableCellStyle}>
                    <input
                      type="text"
                      value={row.entityName}
                      placeholder="Enter Name of Entity"
                      onChange={(e) =>
                        handleInputChange(index, "entityName", e.target.value)
                      }
                      style={inputFieldStyle}
                    />
                  </td>
                  <td style={tableCellStyle}>
                    <select
                      value={row.entityType}
                      onChange={(e) =>
                        handleInputChange(index, "entityType", e.target.value)
                      }
                      style={inputFieldStyle}
                    >
                      <option value="">Select Type of Entity</option>
                      {entityTypes.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td style={tableCellStyle}>
                    <input
                      type="number"
                      value={row.sharePercent}
                      placeholder="Enter share %"
                      onChange={(e) =>
                        handleInputChange(index, "sharePercent", e.target.value)
                      }
                      style={inputFieldStyle}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

// Reused styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default ShareholdingTable;
